<ng-template #content>
  @if (icon()) {
    <ng-container *ngComponentOutlet="icon()"></ng-container>
  }
  @if (displayBadgeCount()) {
    <div class="icon-button__badge body-xs">{{ displayBadgeCount() }}</div>
  }
</ng-template>

@switch (linkType()) {
  @case ('external') {
    <a [href]="routerLink()" [ngClass]="buttonClass()" class="icon-button">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  }
  @case ('router') {
    <a
      [routerLink]="routerLink()"
      routerLinkActive="icon-button--active"
      [routerLinkActiveOptions]="activeOptions()"
      [ngClass]="buttonClass()"
      class="icon-button">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </a>
  }
  @default {
    <button [type]="type()" [ngClass]="buttonClass()" class="icon-button">
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </button>
  }
}
